/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Directive} from '@angular/core';

/** The floating label for a `mat-form-field`. */
@Directive({
  selector: 'mat-label',
})
export class MatLabel {}
